
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  commonModule,
  installationsModule,
  jobsModule,
  partnersModule,
} from "@/store/modules/store-accessor";
import dayjs from "dayjs";
import AssigneeCombo from "@/components/Combobox/AssigneeCombo.vue";
import PaymentAllocation from "@/components/Payments/PaymentAllocation.vue";
import { greekSearchFilter } from "@/helpers/data";

@Component({
  components: {
    AssigneeCombo,
    PaymentAllocation,
  },
})
export default class AddPaymentToJobModal extends Vue {
  @Prop()
  payload!: any;

  greekSearchFilter = greekSearchFilter;

  isAddingPayment = false;
  createdAtMenu = false;
  createdAtTimeMenu = false;
  jobBalance = 0;
  payments: JobPaymentRequestDto[] = [];

  clientsCombo = [
    {
      name:
      this.payload.installation.info.client_is_business ?
      this.$t("tenant") + " (" + this.payload.installation.info.client_entity_name + " - " + this.payload.installation.info.client_lastname + " " + this.payload.installation.info.client_firstname + ")"
      : this.$t("tenant") + " (" + this.payload.installation.info.client_lastname + " " + this.payload.installation.info.client_firstname + ")",
      is_business: this.payload.installation.info.client_is_business,
      id: this.payload.installation.info.user_id
    },
    this.payload.installation.info.owner_id ?
    {
      name: this.payload.installation.info.owner_is_business ?
      this.$t("owner") + " (" + this.payload.installation.info.owner_entity_name + " - " + this.payload.installation.info.owner_lastname + " " + this.payload.installation.info.owner_firstname + ")"
      : this.$t("owner") + " (" + this.payload.installation.info.owner_lastname + " " + this.payload.installation.info.owner_firstname + ")",
      is_business: this.payload.installation.info.owner_is_business,
      id: this.payload.installation.info.owner_id
  } : null
  ].filter((client) => client !== null);

  jobPaymentModel = {
    assignee_id: this.getAssigneeId(this.payload.job.partner_uuid ? this.payload.job.partner_uuid : commonModule.user.uuid),
    installation_id: this.payload.job.installation_id,
    id: this.payload.job.id,
    created_at_date: dayjs().format("YYYY-MM-DD"),
    created_at_time: dayjs().format("HH:mm"),
    partner_id: this.payload.job.partner_id || "",
  };

  get paymentTypesCombo() {
    return commonModule.paymentTypeCombo;
  }

  async mounted() {
    commonModule.initSnackbar({});

    const [jobBalance] = await Promise.all([
      jobsModule.getJobPendingBalance(this.payload.job.id),
      commonModule.getActionCombo(),
      commonModule.getPersonnelCombo(),
      commonModule.getPaymentTypeCombo(),
    ]);

    this.jobBalance = Number(jobBalance);
  }

  updateAssignee(assignee: any) {
    if(assignee) {
      this.jobPaymentModel.assignee_id = assignee;
    }
  }

  updatePayments(payments: JobPaymentRequestDto[]) {
    this.payments = payments;
  }

  hideModal() {
    commonModule.hideModal();
  }

  getAssigneeId(uuid: string) {
      const combo: any = commonModule.personnelPartnersCombo;
      const foundItem = combo.find((item: any) => item.id === uuid);
      if(foundItem) {
        return { name: foundItem.name, id: foundItem.id };
      } else {
        return ''
      }
    }

  async doAddJob () {
    const isFormValid = (this.$refs.form as Vue & { validate: () => boolean }).validate();
    const isAllocationValid = (this.$refs.paymentAllocation as PaymentAllocation).validate();

    if (!isFormValid || !isAllocationValid) {
      return;
    }

    this.isAddingPayment = true;

    try {
      const assignee = this.jobPaymentModel.assignee_id as any;

      const data = {
        id: this.payload.job.id,
        installation_id: this.jobPaymentModel.installation_id,
        partner_id: this.jobPaymentModel.partner_id || undefined,
        created_at: dayjs(`${this.jobPaymentModel.created_at_date} ${this.jobPaymentModel.created_at_time}`).toISOString(),
        assignee_id: assignee && assignee.id ? assignee.id : assignee,
        payments: this.payments,
      };

      await jobsModule.createPaymentToJob(data);
      this.hideModal();

      if (this.$route.name === 'Jobs') {
        jobsModule.getJobs(jobsModule.filters);
      }
    } finally {
      this.isAddingPayment = false;
    }
  }
}

